"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isVNode = isVNode;
exports.getFirstComponentChild = getFirstComponentChild;

var _lodash = _interopRequireDefault(require("lodash.hasin"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function isVNode(node) {
  return node !== null && _typeof(node) === 'object' && (0, _lodash["default"])(node, 'componentOptions');
}

function getFirstComponentChild(children) {
  return children && children.filter(function (c) {
    return c && c.tag;
  })[0];
}